// Paleta e tipografia validadas com o fundador (protótipo web "Ponto Firme").
// Só modo claro — sem dark mode neste app (ver app.json `userInterfaceStyle`).
export const colors = {
  sand: '#f7f2e4',
  sandPanel: '#ece1c7',
  ink: '#2c2f22',
  inkSoft: '#57594a',
  sage: '#6f8259',
  sageDeep: '#445235',
  clay: '#d1885f',
  thread: '#8c8672',
  line: '#ddd0a9',
  onSage: '#f4efdd',
} as const;

export const fonts = {
  display: 'Fredoka_600SemiBold',
  displayBold: 'Fredoka_700Bold',
  body: 'Nunito_400Regular',
  bodyMedium: 'Nunito_600SemiBold',
  bodyBold: 'Nunito_800ExtraBold',
} as const;

export const spacing = { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 } as const;

export const radii = { sm: 12, md: 20, lg: 28, pill: 999 } as const;
